import _ from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';

// Components
import { PlayerList } from './player-list.component';
import { buildPlayerNameMatcher } from '../../../lib/helpers/player-search.helpers';

interface IPlayerListContainer {
  playerAssessments: IPlayerAssessment[];
  loading: boolean;
  fetchError: boolean;
  removePlayerAssessments: Function;
}

export const PlayerListContainer: React.FC<IPlayerListContainer> = ({
  playerAssessments,
  loading,
  fetchError,
  removePlayerAssessments
}) => {
  const [selected, setSelected] = useState<IPlayerAssessment[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const matchPlayerNames = useMemo(() => buildPlayerNameMatcher(playerAssessments, 'player'), [playerAssessments]);

  // Derived, never mirrored in state: an import that refetches the list without changing its row
  // count (merges, skips, refreshed aggregates) still has to reach the table.
  const filteredPlayerAssessments = useMemo(() => matchPlayerNames(searchTerm), [matchPlayerNames, searchTerm]);

  const debounceSearch = useCallback(_.debounce((nextSearch: string) => {
    setSearchTerm(nextSearch)
  }, 300), []);

  return <PlayerList
    loading={loading}
    fetchError={fetchError}
    playerAssessments={filteredPlayerAssessments}
    search={debounceSearch}
    selected={selected}
    setSelected={setSelected}
    removePlayerAssessments={removePlayerAssessments}
  />;
};
